/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pulse_Detail_Offermetadatarefreshed2Inputs */

const id_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata penawaran disegarkan`)
};

const ms_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata tawaran disegarkan`)
};

const da_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbudsmetadata opdateret`)
};

const de_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebots-Metadaten aktualisiert`)
};

const en_us2_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer metadata refreshed`)
};

const es_es2_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos de oferta de catálogo actualizados`)
};

const es_mx2_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos de oferta actualizados`)
};

const fil_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-refresh ang metadata ng offer`)
};

const fr_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métadonnées d'offre actualisées`)
};

const it_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadati dell'offerta aggiornati`)
};

const hu_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat metaadatok frissítve`)
};

const nl_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata van aanbod vernieuwd`)
};

const no_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbudsmetadata oppdatert`)
};

const pl_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadane oferty odświeżone`)
};

const pt_br2_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados da oferta de catálogo atualizados`)
};

const pt_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadados da oferta atualizados`)
};

const ro_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatele ofertei reîmprospătate`)
};

const fi_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjouksen metatiedot päivitetty`)
};

const sv_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudandets metadata uppdaterad`)
};

const vi_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siêu dữ liệu ưu đãi đã làm mới`)
};

const tr_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif meta verileri yenilendi`)
};

const cs_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata nabídky obnovena`)
};

const bg_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданните на офертата са опреснени`)
};

const ru_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные предложения обновлены`)
};

const uk_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метадані пропозиції оновлено`)
};

const ar_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تحديث بيانات العرض الوصفية`)
};

const hi_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र मेटाडेटा रिफ्रेश किया गया`)
};

const th_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตเมทาดาทาของข้อเสนอแล้ว`)
};

const ja_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーメタデータを更新しました`)
};

const zh_cn2_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项元数据已刷新`)
};

const zh_hant1_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目中繼資料已重新整理`)
};

const ko_home_pulse_detail_offermetadatarefreshed2 = /** @type {(inputs: Home_Pulse_Detail_Offermetadatarefreshed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼 메타데이터 새로고침됨`)
};

/**
* | output |
* | --- |
* | "Offer metadata refreshed" |
*
* @param {Home_Pulse_Detail_Offermetadatarefreshed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_detail_offermetadatarefreshed2 = /** @type {((inputs?: Home_Pulse_Detail_Offermetadatarefreshed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Detail_Offermetadatarefreshed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "ms") return ms_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "da") return da_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "de") return de_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "en-US") return en_us2_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "fil") return fil_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "fr") return fr_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "it") return it_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "hu") return hu_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "nl") return nl_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "no") return no_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "pl") return pl_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "pt") return pt_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "ro") return ro_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "fi") return fi_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "sv") return sv_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "vi") return vi_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "tr") return tr_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "cs") return cs_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "bg") return bg_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "ru") return ru_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "uk") return uk_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "ar") return ar_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "hi") return hi_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "th") return th_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "ja") return ja_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_detail_offermetadatarefreshed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_detail_offermetadatarefreshed2(inputs)
	return ko_home_pulse_detail_offermetadatarefreshed2(inputs)
});
export { home_pulse_detail_offermetadatarefreshed2 as "home.pulse.detail.offerMetadataRefreshed" }